/** PUT INTO MAINTENANCE MODE: Disabling service workers for all users **/
import store from '../store';

export default async () => {
	// Does the browser support the service worker?
	if (!('serviceWorker' in navigator) || !window.chrome) {
		console.info('ServiceWorker not supported.'); // eslint-disable-line no-console
		// Nothing more to do here...
		return;
	}

	try {
		// Register a new service worker...
		const registration = await navigator.serviceWorker.register('/sw.js', {
			scope: '/',
		});
		registration.update();

		// Registration was successful
		// eslint-disable-next-line no-console
		console.info(
			'ServiceWorker registered with scope: ',
			registration.scope
		);

		store('sw_maintenance', null); // DEPRECATE this line in the future
	} catch (err) {
		console.info('ServiceWorker registration errored: ', err); // eslint-disable-line no-console
	}
};
